import { useAuth } from '@/contexts/AuthContext';
import OnboardingFlow from './OnboardingFlow';

/**
 * OnboardingWrapper - Shows onboarding flow for new users
 * 
 * Behavior:
 * - If onboarding not completed: show OnboardingFlow
 * - If onboarding completed: show children (actual page)
 * - Failsafe: if state fails to load, show children (never trap user)
 */
const OnboardingWrapper = ({ children }) => {
  const { onboardingCompleted, completeOnboarding, loading } = useAuth();

  // While loading, don't show anything to prevent flash
  if (loading) {
    return null;
  }

  // Failsafe: if somehow undefined, show children
  if (onboardingCompleted === undefined || onboardingCompleted === null) {
    return children;
  }

  // Show onboarding for new users
  if (!onboardingCompleted) {
    return <OnboardingFlow onComplete={completeOnboarding} />;
  }

  // Onboarding completed, show actual content
  return children;
};

export default OnboardingWrapper;
